import { readable, writable } from "svelte/store";
import raceData from '../data/racesData.js';
import { scaleLinear } from 'd3-scale';

const State = writable({
    selChart: "Lightning",
    selDriver: "Max Verstappen",
    selRace: raceData[0],
    prevChart: "Lightning",
    intro: "", 
    l_x: scaleLinear()
            .domain([-100898,87788.5])
            .range([0, 655]),
    l_y: scaleLinear()
            .domain([1, 56])
            .range([35,380]),
    f_x: scaleLinear()
            .domain([90000,0])
            .range([20, 655]),
    f_y: scaleLinear()
            .domain([1, 10])
            .range([35,380]),
    p_x: (x) => {return x},
    // p_y: (y) => {return y},
    chartFirstVisible: false,
    placesFirstVisible: false,
    showNav: false,
    scrollValue: undefined,
    started: false,
    noFade: false,
});

export default State;

export const Drivers = readable({
    "Fernando Alonso": {"num":14,"team":"Alpine"},  
    "Valtteri Bottas": {"num":77,"team":"Mercedes"},
    "Pierre Gasly": {"num":10,"team":"AlphaTauri"},
    "Antonio Giovinazzi": {"num":99,"team":"Alpha Romeo"},
    "Lewis Hamilton": {"num":44,"team":"Mercedes"},
    "Robert Kubica": {"num":88,"team":"Alpha Romeo"},
    "Nicholas Latifi": {"num":6,"team":"Williams"},
    "Charles Leclerc": {"num":16,"team":"Ferrari"},
    "Nikita Mazepin": {"num":9,"team":"Haas"},
    "Lando Norris": {"num":4,"team":"McLaren"},
    "Esteban Ocon": {"num":31,"team":"Alpine"},
    "Sergio Perez": {"num":11,"team":"Red Bull"},
    "Kimi Räikkönen": {"num":7,"team":"Alpha Romeo"}, 
    "Daniel Ricciardo": {"num":3,"team":"McLaren"},
    "George Russell": {"num":63,"team":"Williams"},
    "Carlos Sainz": {"num":55,"team":"Ferrari"},
    "Mick Schumacher": {"num":47,"team":"Haas"},
    "Lance Stroll": {"num":18,"team":"Aston Martin"},
    "Yuki Tsunoda": {"num":22,"team":"AlphaTauri"},
    "Max Verstappen": {"num":33,"team":"Red Bull"},
    "Sebastian Vettel": {"num":5,"team":"Aston Martin"},
});
